import React from 'react';
import forgeIcon from '../../assets/forge-logo.svg';
import './AppFooter.scss';

interface IFooterProps {
  siteImage: string;
  screenOption: string;
  deviceName: string;
  disclaimerText:string;
  disclaimerClassName:string;
}
const AppFooter = (props: IFooterProps) => {
  let siteImageCondition;
  let screenOption = props.screenOption.toLowerCase();
  let footerClassName;
  if (screenOption === 'landscape') {
    footerClassName = 'footer-container';
  } else {
    footerClassName = 'footer-container footer-container-portrait';
  }
  if (props.siteImage) {
    siteImageCondition = <img src={props.siteImage} className="site-icon" />;
  } else {
    siteImageCondition = '';
  }
  //rendering of Footer tsx
  return (
    <div className={footerClassName}>
       <div className="honeywell-icons">
        <img src={forgeIcon} className="company-icon" />
        {siteImageCondition}
      </div>
      <div className="device-id">{props.deviceName}</div>
     
      <div className={"disclaimer-text " + props.disclaimerClassName}>{props.disclaimerText}</div>
    </div>
  );
};
export default AppFooter;
